<script>
export default {
  props: {
    item: {
      type: Object
    },
    content: {
      type: Object
    },
    order: {
      type: [Object, Array]
    }
  },
  data() {
    return {
      isLoading: false
    }
  },
  methods: {
    async deleteCoverSheet() {
      this.isLoading = true
      await this.$coverSheetService
          .removeCoverSheetFromDocument(this.item.documentId)
          .then(() => {
            this.$emit('cover-sheet-deleted')
          })
          .catch((error) => {
            console.error('Delete Coversheet: ', error)
          })
          .finally(() => {
            this.isLoading = false
          })
    }
  }
}
</script>
<template>
  <v-expansion-panel
    v-if="item.hasOwnProperty('coverSheetId') && item.coverSheetId !== null">
    <v-expansion-panel-header>
      {{ $t('component.documentValidation.documentDetailsCoverSheet.header') }}
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-list id="coverSheetDetails" class="pt-0 pb-0">
        <v-row>
          <v-col>
            <span style="font-size:15px;"><b>Empfänger</b></span><br>
            <span style="font-size:15px;">{{ item.recipientInfo.recipient }}</span> <br>
            <span style="font-size:15px;">{{ item.recipientInfo.street }} {{ item.recipientInfo.houseNumber }}</span>
            <br>
            <span style="font-size:15px;">{{ item.recipientInfo.zipCode }} {{ item.recipientInfo.city }}</span>
          </v-col>
        </v-row>
        <v-list-item-action
          v-if="order.hasOwnProperty('orderStatus') && order.orderStatus < 400"
          class="mb-0 ml-0">
          <v-btn
            id="deleteCoverSheet"
            block
            :loading="isLoading"
            color="error"
            @click="deleteCoverSheet">
            <v-icon dark>mdi-delete-forever</v-icon>
            {{ $t('button.delete') }}
          </v-btn>
        </v-list-item-action>
      </v-list>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<style lang="scss" scoped>
.v-list-item {
  min-height: 28px;
}
.v-list-item__content {
  padding: 0 !important;
}
</style>
